/* tslint:disable */
/* eslint-disable */
/**
 * CallNowButton API
 * API for CallNowButton. Includes auth, domains, buttons/actions/conditions, but also chat and admin features.
 *
 * The version of the OpenAPI document: 0.0.221-development
 * Contact: support@nowbuttons.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ChatChannelResolutionUpdateRequest
 */
export interface ChatChannelResolutionUpdateRequest {
    /**
     * The new resolution for this chat channel
     * @type {string}
     * @memberof ChatChannelResolutionUpdateRequest
     */
    resolution: ChatChannelResolutionUpdateRequestResolutionEnum;
}


/**
 * @export
 */
export const ChatChannelResolutionUpdateRequestResolutionEnum = {
    Resolved: 'RESOLVED',
    Unresolved: 'UNRESOLVED'
} as const;
export type ChatChannelResolutionUpdateRequestResolutionEnum = typeof ChatChannelResolutionUpdateRequestResolutionEnum[keyof typeof ChatChannelResolutionUpdateRequestResolutionEnum];


/**
 * Check if a given object implements the ChatChannelResolutionUpdateRequest interface.
 */
export function instanceOfChatChannelResolutionUpdateRequest(value: object): value is ChatChannelResolutionUpdateRequest {
    if (!('resolution' in value) || value['resolution'] === undefined) return false;
    return true;
}

export function ChatChannelResolutionUpdateRequestFromJSON(json: any): ChatChannelResolutionUpdateRequest {
    return ChatChannelResolutionUpdateRequestFromJSONTyped(json, false);
}

export function ChatChannelResolutionUpdateRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ChatChannelResolutionUpdateRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'resolution': json['resolution'],
    };
}

export function ChatChannelResolutionUpdateRequestToJSON(json: any): ChatChannelResolutionUpdateRequest {
    return ChatChannelResolutionUpdateRequestToJSONTyped(json, false);
}

export function ChatChannelResolutionUpdateRequestToJSONTyped(value?: ChatChannelResolutionUpdateRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'resolution': value['resolution'],
    };
}

